var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"showMemo"},[_c('div',{staticClass:"memo",domProps:{"innerHTML":_vm._s(_vm.memo)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }